import { createConfig, http } from 'wagmi';
import { bsc, bscTestnet } from 'wagmi/chains';
import {
  baseAccount,
  coinbaseWallet,
  injected,
  metaMask,
} from 'wagmi/connectors';
import { APP_LOGO_URL, APP_NAME } from '../constants';
import { clientEnv } from '../env';

export const currentChain =
  clientEnv.VITE_NETWORK_MODE === 'testnet' ? bscTestnet : bsc;

export const wagmiConfig = createConfig({
  chains: [currentChain],
  connectors: [
    injected(),
    baseAccount({
      appName: APP_NAME,
      appLogoUrl: APP_LOGO_URL,
    }),
    metaMask({
      dappMetadata: {
        name: APP_NAME,
        url: location.origin,
        iconUrl: APP_LOGO_URL,
      },
    }),
    coinbaseWallet({
      appName: APP_NAME,
      appLogoUrl: APP_LOGO_URL,
    }),
  ],
  syncConnectedChain: true,
  transports: {
    [bsc.id]: http(),
    [bscTestnet.id]: http(),
  },
});
